import { FlaskConical } from 'lucide-react';
import { IS_STAGING } from '@/config/env';

/**
 * Thin, non-dismissable "not production" marker. Renders only in staging builds
 * (VITE_SIMCHECK_ENV=staging), so nobody mistakes the staging console for prod.
 */
export function StagingBanner() {
  if (!IS_STAGING) return null;
  return (
    <div
      role="status"
      className="relative z-50 flex h-6 shrink-0 items-center justify-center gap-1.5 bg-destructive text-xs font-semibold tracking-wide text-destructive-foreground"
    >
      <FlaskConical className="size-3.5" aria-hidden="true" />
      STAGING — not production
    </div>
  );
}
